export type SourceTabOptions = "literature-notes" | "permanent-notes" | "extracted-text"

// Reading view is a route, not a persistable tab. A leftover "reading-pane"
// value must not be restored, or closing the reader immediately reopens it.
export function chooseInitiallyOpenTab(
  saved: string,
  showLiteratureNotes: boolean,
  showMosaicNotes: boolean,
  showExtractedText = false,
): SourceTabOptions {
  if (saved == "literature-notes" && showLiteratureNotes) return saved
  if (saved == "permanent-notes" && showMosaicNotes) return saved
  if (saved == "extracted-text" && showExtractedText) return saved
  if (showLiteratureNotes) return "literature-notes"
  if (showMosaicNotes) return "permanent-notes"
  if (showExtractedText) return "extracted-text"
  return "literature-notes"
}
